import { gql } from '@apollo/client'
import { ICampaignRepository } from '../../domain/repositories/Campaign'
import { Campaign, CampaignInput } from '../../domain/entities/Campaign'
import { createAuthClient } from './client'

export class GraphQLCampaignRepository implements ICampaignRepository {
  constructor(private getToken: () => Promise<string>) {}
  private client = createAuthClient(
    process.env.REACT_APP_CAMPAIGNS_GRAPHQL_URL!,
    this.getToken
  )

  async fetchAll(): Promise<Campaign[]> {
    const QUERY = gql`
      query CampaignByUser {
        campaignsByUser {
          id
          title
          status
          vastUrl
          createdAt
        }
      }
    `
    const { data } = await this.client.query<{ campaignsByUser: Campaign[] }>({
      query: QUERY,
    })
    return data.campaignsByUser
  }

  async create(campaign: CampaignInput): Promise<string> {
    const MUTATION = gql`
      mutation CreateCampaign(
        $title: String!
        $status: String!
        $vastUrl: String!
      ) {
        createCampaign(title: $title, status: $status, vastUrl: $vastUrl) {
          id
        }
      }
    `
    const { data } = await this.client.mutate({
      mutation: MUTATION,
      variables: {
        title: campaign.title,
        status: campaign.status,
        vastUrl: campaign.vastUrl,
      },
    })
    return data.createCampaign.id
  }

  async update(campaign: CampaignInput): Promise<void> {
    const MUTATION = gql`
      mutation UpdateCampaign(
        $id: String!
        $title: String
        $status: String
        $vastUrl: String
      ) {
        updateCampaign(
          id: $id
          title: $title
          status: $status
          vastUrl: $vastUrl
        ) {
          id
          title
          status
          createdAt
        }
      }
    `
    await this.client.mutate({
      mutation: MUTATION,
      variables: { ...campaign },
    })
  }
  async delete(id: string): Promise<void> {
    const MUTATION = gql`
      mutation DeleteCampaign($id: String!) {
        deleteCampaign(id: $id)
      }
    `
    await this.client.mutate({
      mutation: MUTATION,
      variables: { id },
    })
  }
}
